function getLocalStoragePolyfill () {
  let storage = {}
  return {
    getItem (key) { return storage[key] || null },
    setItem (key, value) {
      storage[key] = value
    },
    clear () { storage = {} },
  }
}

// If localStorage isnt supported (or more probably, blocked),
// replace it by a global object: data won't be persisted from one session to the other
let _localStorageProxy
try {
  if ('localStorage' in globalThis) {
    globalThis.localStorage?.setItem('localStorage-support', 'true')
    _localStorageProxy = localStorage
  } else {
    // Typically in test env
    _localStorageProxy = getLocalStoragePolyfill()
  }
} catch (err) {
  console.warn('localStorage isnt supported', err)
  _localStorageProxy = getLocalStoragePolyfill()
}

export const localStorageProxy = _localStorageProxy
